import { Header, Layout, PageContent } from '@loadsmart/miranda-react'

import { PendingResponses } from './PendingResponses/PendingResponses'
import { SpotQuoteList } from './SpotQuoteList'

export default function BidsPanel() {
  return (
    <PageContent>
      <Header>
        <Header.Content>
          <Header.Title>Bid Invites</Header.Title>
        </Header.Content>
      </Header>
      <PageContent.Body>
        <Layout.Stack>
          <PendingResponses />
          <SpotQuoteList />
        </Layout.Stack>
      </PageContent.Body>
    </PageContent>
  )
}
